import czech from "./cs";
import deutsch from "./de";
import english from "./en";
import polish from "./pl";
import slovak from "./sk";
import ukrainian from "./uk";


const translation = {
    cs : czech,
    de : deutsch,
    en : english,
    pl : polish,
    sk : slovak,
    uk : ukrainian
}

export default translation;
